import React from 'react';
import { Form, Input, Select, Button, Row, Col, Tooltip } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { FormattedMessage, injectIntl } from 'react-intl';

import CountrySelect from 'components/CountrySelect';
import { QUESTION_TYPES } from 'shared/constants/survey';
import messages from './messages';

const { FIELD, RADIO, CHECKBOX, SENTIMENT, THUMBS, NPS, COUNTRY, GRADE, FIND } = QUESTION_TYPES;
const { Option } = Select;

const EditDependencies = ({ intl: { formatMessage: $t }, questions }) => (
  <>
    <Form.List name="dependencies">
      {(fields, { add, remove }) => (
        <>
          {fields.map(field => (
            <Row key={field.key} wrap={false} align="middle" gutter={16}>
              <Col span={12}>
                <Form.Item name={[field.name, 'questionId']} label={<FormattedMessage {...messages.dependencyQuestionLabel} />}>
                  <Select
                    allowClear
                    placeholder={$t(messages.dependencyQuestionPlaceholder)}
                  >
                    {questions.filter(q => [FIELD, RADIO, CHECKBOX, SENTIMENT, THUMBS, NPS, GRADE, FIND, COUNTRY].includes(q.settings.type)).map(q => <Option key={q.id} value={q.id}>{q.title}</Option>)}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    let input;
                    let fieldName = 'answer';

                    const questionId = getFieldValue(['dependencies', field.name, 'questionId']);
                    const question = questions.find(q => q.id === questionId);

                    switch (question?.settings.type) {
                      case COUNTRY:
                        input = <CountrySelect />;
                        break;
                      case RADIO:
                      case CHECKBOX:
                      case SENTIMENT:
                      case THUMBS:
                      case NPS:
                      case GRADE:
                      case FIND:
                        input = (
                          <Select
                            allowClear
                            mode="multiple"
                            placeholder={$t(messages.dependencyOptionPlaceholder)}
                          >
                            {question.options.map(o => <Option key={o.id} value={o.id}>{o.title}</Option>)}
                          </Select>
                        );
                        fieldName = 'optionIds';
                        break;
                      default:
                        input = <Input placeholder={$t(messages.dependencyAnswerPlaceholder)} />;
                    }

                    return (
                      <Form.Item name={[field.name, fieldName]} label={<FormattedMessage {...messages.dependencyAnswerLabel} />}>
                        {input}
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Col>
              <Col span={2}>
                <Tooltip title={<FormattedMessage {...messages.dependencyRemove} />}>
                  <MinusCircleOutlined onClick={() => remove(field.name)} />
                </Tooltip>
              </Col>
            </Row>
          ))}
          <Form.Item>
            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
              <FormattedMessage {...messages.dependencyAdd} />
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
    <Form.Item shouldUpdate={(prevValues, curValues) => prevValues.dependencies.length !== curValues.dependencies.length}>
      {({ getFieldValue }) => (
        <Form.Item name="dependencyOperator" label={<FormattedMessage {...messages.dependencyOperator} />}>
          <Select disabled={getFieldValue('dependencies').length < 2}>
            <Option value="AND"><FormattedMessage {...messages.dependencyOperatorAnd} /></Option>
            <Option value="OR"><FormattedMessage {...messages.dependencyOperatorOr} /></Option>
          </Select>
        </Form.Item>
      )}
    </Form.Item>
  </>
);
export default injectIntl(EditDependencies);
